import styled from 'styled-components';
import React from "react";

const Wrapper = styled.div`
    width: 100%;
    max-width: 80rem;
    margin: 0 auto;
    padding: 0 1.5rem;
    box-sizing: border-box;

    @media (max-width: 50rem) {
        padding: 0 1rem;
    }
`

type SteppedPageProps = {
    children?: React.ReactNode;
}

export default function SteppedPage({children}: SteppedPageProps) {
    return (
        <Wrapper>
            {children}
        </Wrapper>
    )
}